import ApiServiceBase from '@/services/ApiServiceBase'
import router from '@/router/index'
import store from '@/store/store'

class LocalAuthService {
  constructor () {
    ApiServiceBase.http.interceptors.response.use(
      response => {
        return response
      },
      error => {
        if (error.handled === true) {
          // TODO: this
        } else if (error.response) {
          const status = error.response.status
          switch (status) {
            case 401:
              store.dispatch('snackbar/showSnackbar', { message: "Your session has expired. Please log in again." });
              router.push(this.getLoginRoute())
            // eslint-disable-next-line no-fallthrough
            case 403:
            case 404:
              router.push({
                name: 'Error',
                params: {
                  errorCode: String(status)
                }
              })
            // eslint-disable-next-line no-fallthrough
            default:
              return Promise.reject(error)
          }
        } else {
          return Promise.reject(error)
        }
      }
    )
  }

  /**
   * Gets a valid Route object to the 'Login' route, appending the 'redirect'
   * querystring when appropriate.
   * @returns {Route}
   */
  getLoginRoute (fromRoute) {
    const redirectPath = window.location.pathname

    if (redirectPath.length && (!fromRoute || fromRoute.name !== 'Logout')) {
      return { name: 'Login', query: { redirect: redirectPath } }
    } else {
      return { name: 'Login' }
    }
  }

  /**
   * Gets the current user.
   * @returns {Promise<User | null>}
   */
  getCurrentUser (userId) {
    return new Promise((resolve, reject) => {
      ApiServiceBase.get({
        resource: 'auth/user',
        id: userId,
        query: null
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(err => {
          reject(err)
        })
    })
  }

  /**
   * Initiates a login
   * @param {string} emailAddress User's account email address
   * @param {'sms'|'voice'|'onetouch'} type Type of verification requested
   * @returns {Promise}
   */
  requestLogin (emailAddress, type) {
    return new Promise((resolve, reject) => {
      return ApiServiceBase.post({
        resource: `auth/accountsecurity/${type}`,
        data: {
          emailAddress: emailAddress
        },
        query: null
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(err => {
          reject(err)
        })
    })
  }

  /**
   * Complete a login request and retrieve an access token.
   * @returns {Promise<AccessToken>}
   */
  completeLogin (emailAddress, token) {
    return new Promise((resolve, reject) => {
      return ApiServiceBase.post({
        resource: 'auth/accountsecurity/verify',
        data: {
          emailAddress: emailAddress,
          token: token
        },
        query: null
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(err => {
          reject(err)
        })
    })
  }
}

export default new LocalAuthService()
